import { Input, Form } from 'antd'
import { observer } from 'mobx-react-lite'
import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ERROR_CODES } from '../../helpers/constants'
import { useStore } from '../../hooks'
import { UserOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import Images from 'src/common/Images'
import { showMessageSuccess } from 'src/helpers/functions'
import { debounce } from 'lodash'
import { AuthenWrapper, SignupWrapper } from 'src/styles/login/Authen.style'
import BaseButton from 'src/common/components/button'
import i18n from 'src/helpers/i18n'
import { createValidationRules } from 'src/helpers/validateRule'

const LoginScreen = observer((props: any) => {
   const AuthStore = useStore('AuthStore')
   const { t } = useTranslation()
   const [isLoading, setIsLoading] = useState(false)
   // const { history } = props
   const [form] = Form.useForm()
   // Re-create rules when language changes
   const rule = useMemo(() => createValidationRules(), [i18n.language])
   const onFinishFailed = (errorInfo: any) => {}

   const onFinish = async (values: any) => {
      try {
         setIsLoading(true)

         Object.keys(values).forEach((k) => (values[k] = values[k].trim()))
         const result = await AuthStore.action_forgotPassword(values)
         if (result?.code === ERROR_CODES.SUCCESS) {
            showMessageSuccess(t('confirm_email_success'))
         }
      } catch (error) {
         //  console.log(error)
      } finally {
         setIsLoading(false)
      }
   }

   return (
      <AuthenWrapper>
         {/* <Loading isLoading={isLoading} /> */}
         <div className="login__banner">
            <img src={Images.bg_login} alt="" />
         </div>
         <SignupWrapper className="login__content">
            <div className="signup-content__body">
               <div className="signup-content__form">
                  <div className="form__title"> {t('forgot_password')}</div>
                  <div className="form__desc">{t('enter_verify_email')}</div>
                  <Form
                     form={form}
                     name="basic"
                     onFinish={debounce(onFinish, 600)}
                     onFinishFailed={onFinishFailed}
                     className="gx-signin-form gx-form-row0 signup-form__content"
                  >
                     <Form.Item rules={[rule.emailRule, rule.requiredEmail]} name="email">
                        <Input
                           placeholder={t('email')}
                           prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                           maxLength={30}
                        />
                     </Form.Item>
                     <Form.Item style={{ marginBottom: 'unset', marginTop: '24px' }}>
                        <div className="signup-form__footer">
                           <div className="signin__link">
                              <Link to="/signin">{t('login')}</Link>
                           </div>
                           <BaseButton type="primary" className="gx-mb-0 gx-px-4">
                              {t('submit')}
                           </BaseButton>
                        </div>
                     </Form.Item>
                  </Form>
               </div>
            </div>
         </SignupWrapper>
      </AuthenWrapper>
   )
})

export default LoginScreen
